@if (versionsService.loading$ | async) {
  <div>
    <mat-spinner></mat-spinner>
  </div>
}
@if (!(versionsService.loading$ | async)) {
  <div class="version-data">
    <div class="top-label">
      <h3>File History</h3>
      <span class="action-buttons"
        ><button (click)="setExpandAll(true)" mat-button mat-raised-button>
        Expand All</button
        ><button (click)="setExpandAll(false)" mat-button mat-raised-button>
        Collapse All
      </button></span
      >
    </div>
    @if (permission | permission: '_edit') {
      <button
        mat-button
        (click)="addFileHistory()"
        mat-raised-button>
        Add Historical Data
      </button>
    }
    @for (subType of (subTypeMap$ | async); track subType; let i = $index) {
      <div class="subtype-container">
        <div class="subtype-label">
          <span class="subtype-info">
            <span>{{ subType.subType }}</span>
            @if (subType.due_date) {
              <span class="due">
                <span>Due Date:</span>
                <span>{{subType.due_date | date: "MM/dd/yyyy"}}</span>
              </span>
            }
            @if (i !== 0 && (permission | permission:'_delete')) {
              <button mat-icon-button color="warn" (click)="deleteSubtypeVersions(subType)"><mat-icon>delete</mat-icon></button>
            }
          </span>
          <span>
            <button
              mat-icon-button
              class="expand-button"
              (click)="subType.expanded = !subType.expanded"
              [class]="{ expand: subType.expanded }">
              <mat-icon>keyboard_arrow_down</mat-icon>
            </button>
          </span>
        </div>
        <div class="subtype-details" [class]="{ expand: subType?.expanded }">
          @for (version of subType.statusVersions; track version; let j = $index) {
            <div
              class="version-container"
              >
              <div class="version-label">
                <span class="version-title">
                  <span>Version {{ version.version }}</span>
                  @if (j !== (subType.statusVersions.length-1) && (permission | permission: '_delete')) {
                    <button mat-icon-button color="warn" (click)="deleteStatusVersion(version, subType)"><mat-icon>delete</mat-icon></button>
                  }
                </span>
                <span>
                  <button
                    mat-icon-button
                    class="expand-button"
                    [class]="{ expand: version?.expanded }"
                    (click)="version.expanded = !version?.expanded">
                    <mat-icon>keyboard_arrow_down</mat-icon>
                  </button>
                </span>
              </div>
              <div class="version-details" [class]="{ expand: version?.expanded }">
                @for (statusVersion of version?.versions; track statusVersion; let k = $index) {
                  <div
                    class="version-status"
                    >
                    <div class="label-bar">
                      <span class="status-version-info">
                        <span class="status-version-label">{{
                          statusVersion.label
                        }}</span>
                        <span class="status-version-date">
                          <span>
                            <label>Status Date:</label>
                            <input
                      [disabled]="
                        statusVersion.isCurrent ||
                        !(permission | permission: '_edit')
                      "
                              class="date"
                              [(ngModel)]="statusVersion.version.status_date"
                              type="date"
                              matInput />
                          </span>
                          @if (!statusVersion.isCurrent) {
                            <span>
                              <button
                                mat-icon-button
                                (click)="saveVersion(statusVersion.version)">
                                <mat-icon>save</mat-icon>
                              </button>
                            </span>
                          }
                          <span class="user-updated">
                            <span>Updated By:</span>
                            <span>{{statusVersion.version.user?.person?.name ?? 'System'}}</span>
                          </span>
                          @if (k !== 0 && (permission | permission: '_delete')) {
                            <button mat-icon-button color="warn" (click)="deleteVersion(statusVersion, version, subType)"><mat-icon>delete</mat-icon></button>
                          }
                        </span>
                      </span>
                      <button
                        mat-icon-button
                        class="expand-button"
                        [class]="{ expand: statusVersion.expanded }"
                        (click)="statusVersion.expanded = !statusVersion.expanded">
                        <mat-icon>keyboard_arrow_down</mat-icon>
                      </button>
                    </div>
                    <div class="notes" [class]="{ expand: statusVersion.expanded }">
                      <document-notes
                      [statusVersion]="statusVersion.version"></document-notes>
                    </div>
                  </div>
                }
              </div>
            </div>
          }
        </div>
      </div>
    }
  </div>
}
